import React, { useEffect, useRef, useState } from "react";
import { FaCheck, FaCopy, FaTimes } from "react-icons/fa";

import GroupInviteQRCode from "../../../../components/GroupInviteQRCode/GroupInviteQRCode";

function InviteModal({ isOpen, group, inviteLink, onClose }) {
  const closeButtonRef = useRef(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    setCopied(false);
    closeButtonRef.current?.focus();

    const handleKeyDown = (keyboardEvent) => {
      if (keyboardEvent.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleCopy = async () => {
    if (!inviteLink) return;

    await navigator.clipboard.writeText(inviteLink);
    setCopied(true);
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-slate-950/70 px-3 backdrop-blur-sm sm:items-center sm:px-4">
      <div className="relative flex max-h-[92vh] w-full max-w-xl flex-col overflow-hidden rounded-t-[2rem] border border-white/20 bg-white shadow-2xl dark:bg-slate-900 sm:rounded-[2rem]">
        <div className="border-b border-slate-200 bg-gradient-to-br from-emerald-700 to-sky-600 p-5 text-white dark:border-white/10">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-white/65">
                Invitation
              </p>

              <h2 className="mt-2 font-titre text-2xl font-bold">
                Groupe {group?.nom}
              </h2>

              <p className="mt-2 text-sm font-medium text-white/70">
                Partage ce lien ou ce QR code avec les judokas concernés.
              </p>
            </div>

            <button
              ref={closeButtonRef}
              type="button"
              onClick={onClose}
              className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/15 text-white backdrop-blur-xl transition hover:bg-white/25"
              aria-label="Fermer"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 sm:p-6">
          <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
              Lien d'invitation
            </p>

            <p className="mt-2 break-all text-sm font-bold text-sky-700 dark:text-sky-200">
              {inviteLink || "Lien indisponible"}
            </p>

            <button
              type="button"
              onClick={handleCopy}
              disabled={!inviteLink}
              className="mt-4 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl bg-sky-600 px-4 py-2 text-sm font-bold text-white transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
            >
              {copied ? <FaCheck /> : <FaCopy />}
              {copied ? "Lien copié" : "Copier le lien"}
            </button>
          </div>

          {inviteLink && (
            <div className="mt-5 rounded-[1.5rem] border border-slate-200 bg-white p-5 dark:border-white/10 dark:bg-white/[0.03]">
              <p className="text-center text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
                QR Code
              </p>

              <div className="mt-4 flex justify-center">
                <GroupInviteQRCode inviteLink={inviteLink} />
              </div>
            </div>
          )}
        </div>

        <div className="sticky bottom-0 border-t border-slate-200 bg-white p-4 dark:border-white/10 dark:bg-slate-900">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
          >
            <FaTimes />
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}

export default InviteModal;